<template>
    <div class="order-1click">
        <form @submit.prevent="submit()" name="order-1click" method="post" >
            <div class="form__inputs">
                <div class="form__inputs-input">
                    <div class="default-input">
                        <input v-model="name" name="name" type="text" required="" class="default-input__input" />
                        <label for="">ФИО</label>
                    </div>
                </div>
                <div class="form__inputs-input">
                    <div class="default-input">
                        <input-phone v-model="phone" pattern="\+[0-9]\s?[\(][0-9]{3}[\)]\s?[0-9]{3}[-][0-9]{2}[-][0-9]{2}" name="phone" required="" class="default-input__input" ></input-phone>
                        <label for="">Телефон</label>
                    </div>
                </div>
                <div class="forms-checkbox-wrap forms-input-cont">
                    <span v-html="userData.confirmationHtml"></span>
                </div>
                <div class="controls">
                    <input name="submit" type="submit" class="btn" value="Отправить" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name : 'OrderOneClick',
    data : () => ({
        name : '',
        phone : '',
    }),
    computed : {
        userData () {
            return this.$store.state.initialData.userData || {};
        },
    },
    watch : {
        userData () {
            this.name = this.userData.name;
            this.phone = this.userData.phone;
        },
    },
    methods : {
        submit () {
            this.$store.dispatch('loadCartData').then(() => {
                if (!this.$store.state.cart.items.length) {
                    this.$root.alert('Добавьте товары в корзину', 'error');
                    return;
                }
                fetch('/api/v1/order/one-click/', {
                    method : 'POST',
                    body : new FormData(this.$el.querySelector('form'))
                })
                .then(res => res.json())
                .then(res => {
                    if (res) {
                        if (res.message) {
                            this.$root.alert(res.message);
                        }
                        if (res.success) {
                            this.$emit('order-added');
                            this.$root.alert('Заказ успешно оформлен, ожидайте звонка оператора');
                            this.$store.dispatch('loadCartData');
                        }
                    }
                    else {
                        this.$root.alert('Что-то пошло не так. Попробуйте повторить попытку позже', 'error');
                    }
                });
            });
        },
    },
}
</script>
